import React from 'react'
import _ from 'lodash'

const ExpandedRow = ({row, renderSubComponent, getTrProps}) => {
  // the expanded row, if there is one
  if (row.getIsExpanded()) {
    const subComponent = renderSubComponent({ row })
    if (subComponent) {
      return (
        <tr
          {
            ...getTrProps?.(
              row,
              {},
              true
            )
          }
        >
          {/* 2nd row is a custom 1 cell row */}
          <td colSpan={row.getVisibleCells().length}>
            {renderSubComponent({ row })}
          </td>
        </tr>
      )
    } else {
      return null
    }
  } else {
    return null
  }
}

export default ExpandedRow